RivalIQ.apps.Overview.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {
    'use strict';

    const Glance = RivalIQ.apps.Dashboard.views.ColumnWidgets.mixin({
        columnWidth: 3,
        panelView: undefined,

        className: 'panel-body glance-widget',

        dashboardModelEvents: {
            'change': 'reload'
        },

        getPngView: function (child) {
            return child.getView();
        },

        initialize: function () {
            const me = this;
            me.collection = me.dashboardModel.getWidgets();
        }
    });

    function getWidgets(props) {
        const me = this;
        const channel = me.getProp('channel');

        const metric = new RivalIQ.models.MetricDefinition({});

        // Cross-Channel
        if (_.isUndefined(channel)) {
            return [
                {
                    instanceId: 'presence_reach',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    props: {
                        submetricDisplayType: 'upDownCarets'
                    },
                    metric: metric.build({
                        dimensions: ['companyId', 'timeAnalysisMode'],
                        abbreviatedName: 'Your Audience',
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                        property: 'audience'
                    }),
                    submetric: metric.build({
                        dimensions: ['companyId', 'timeAnalysisMode'],
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                        property: 'audience'
                    })
                },
                {
                    instanceId: 'count',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    props: {
                        submetricDisplayType: 'upDownCarets'
                    },
                    metric: metric.build({
                        dimensions: ['companyId', 'timeAnalysisMode'],
                        abbreviatedName: 'Your Posts',
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                        property: 'count'
                    }),
                    submetric: metric.build({
                        dimensions: ['companyId', 'timeAnalysisMode'],
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                        property: 'count'
                    })
                },
                {
                    instanceId: 'engagement_total',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    props: {
                        submetricDisplayType: 'upDownCarets'
                    },
                    metric: metric.build({
                        dimensions: ['companyId', 'timeAnalysisMode'],
                        abbreviatedName: 'Your Engagement Total',
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                        property: 'engagement_total'
                    }),
                    submetric: metric.build({
                        dimensions: ['companyId', 'timeAnalysisMode'],
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                        property: 'engagement_total'
                    })
                },
                {
                    instanceId: 'most_engaging_channel',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    props: {
                        submetricDisplayType: 'mostEngagingCrossChannel',
                        showSparkline: false
                    },
                    metric: metric.build({
                        dimensions: ['channel', 'companyId', 'timeAnalysisMode'],
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                        property: 'engagement_total',
                        name: 'Most Engaging Channel',
                        description: RivalIQ.strings.overview_glance_most_engagement_channel
                    })
                }
            ];
        } else {
            const postWord = RivalIQ.data.channels.get(channel).get('postName');
            return [
                {
                    instanceId: 'presence_reach',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    props: {
                        submetricDisplayType: 'upDownCarets'
                    },
                    metric: metric.build({
                        dimensions: ['channel', 'companyId', 'timeAnalysisMode'],
                        abbreviatedName: (channel === 'facebook' ? 'Your Page Fans' : 'Your Followers'),
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                        property: 'audience',
                        channel: channel
                    }),
                    submetric: metric.build({
                        dimensions: ['channel', 'companyId', 'timeAnalysisMode'],
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                        property: 'audience'
                    })
                },
                {
                    instanceId: 'count',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    props: {
                        submetricDisplayType: 'upDownCarets'
                    },
                    metric: metric.build({
                        dimensions: ['channel', 'companyId', 'timeAnalysisMode'],
                        abbreviatedName: `Your ${postWord}s`,
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                        property: 'count',
                        channel: channel
                    }),
                    submetric: metric.build({
                        dimensions: ['channel', 'companyId', 'timeAnalysisMode'],
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                        property: 'count'
                    })
                },
                {
                    instanceId: 'engagement_total',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    props: {
                        submetricDisplayType: 'upDownCarets'
                    },
                    metric: metric.build({
                        dimensions: ['channel', 'companyId', 'timeAnalysisMode'],
                        abbreviatedName: 'Your Engagement Total',
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                        property: 'engagement_total',
                        channel: channel
                    }),
                    submetric: metric.build({
                        dimensions: ['channel', 'companyId', 'timeAnalysisMode'],
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                        property: 'engagement_total'
                    })
                },
                {
                    instanceId: 'avg_engagement_rate_per_post',
                    widgetId: RivalIQ.enums.widgetTypes.METRIC,
                    props: {
                        submetricDisplayType: 'upDownCarets'
                    },
                    metric: metric.build({
                        dimensions: ['channel', 'companyId', 'timeAnalysisMode'],
                        name: (channel === 'facebook' ? 'Your Engagement Rate by Page Fan' : 'Your Engagement Rate by Follower'),
                        abbreviatedName: 'Your Eng. Rate',
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                        property: 'avg_engagement_rate_per_post',
                        channel: channel
                    }),
                    submetric: metric.build({
                        dimensions: ['channel', 'companyId', 'timeAnalysisMode'],
                        companyId: props.focusCompanyId,
                        timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE,
                        property: 'avg_engagement_rate_per_post'
                    })
                }
            ];
        }
    }

    const Widget = RivalIQ.apps.Dashboard.widgets.ChartWidget;
    const GlanceWidget = Widget.mixin({
        filter: _.constant(false),
        isSupported: _.constant(true),
        description: RivalIQ.strings.favorites_chart_type_focus_company_at_a_glance_description,

        title: function () {
            const me = this;
            const focusCompany = RivalIQ.state.landscape.getCompanyById(me.getProp('focusCompanyId'));
            const companyName = (focusCompany ? focusCompany.get('name') : '');
            return RivalIQ.str('overview_glance_widget_title', companyName);
        },

        view: Glance,

        viewMore: false,

        mixins: {
            userSettingsChanged: RivalIQ.apps.Dashboard.mixins.UserSettingsChanged
        },

        onUserSettingsChanged: function () {
            const me = this;
            if (!me.curation.isCustomDashboard) {
                me.setProps('interval', RivalIQ.apps.Dashboard.views.IntervalDropdown.getGroupByInterval(me.getProps()));
            }
        },

        processProps: function (props) {
            const me = this;

            me.widgetId = me.id;
            props.showSparkline = true;

            if (!me.curation.isCustomDashboard && !me.isExporting()) {
                props.interval = RivalIQ.apps.Dashboard.views.IntervalDropdown.getGroupByInterval(me.getProps());
            }

            return props;
        },

        widgetDefinitions: function () {
            const me = this;
            return getWidgets.call(me, me.getProps());
        },

        getExportSubtitle: function () {
            const me = this;
            if (me.isFocus()) {
                const timezone = RivalIQ.state.landscape.get('timezone');
                return RivalIQ.utils.timePeriod.getTimePeriodDisplayString(me.getProp('timePeriod'), null, timezone);
            }
        },

        getMetricDefinitions: function () {
            const me = this;
            const attrs = me.widgets.map(function (widget) {
                const channel = RivalIQ.props.getChannel(me.getProps);
                return _.defaults({
                    submetricDisplayType: widget.getProp('submetricDisplayType'),
                    source: channel.get('source')
                }, widget.metric.attributes);
            });

            const props = me.getProps();
            const metrics = me.buildMetrics(props, attrs);

            return new RivalIQ.collections.MetricDefinitions(metrics);
        },

        getExportMetricDefinitions: function (format) {
            const me = this;

            const collection = me.getMetricDefinitions();
            return collection.invoke('serialize', format);
        },

        csvExportProps: function () {
            const me = this;

            const definitions = me.getExportMetricDefinitions('csv');
            const metrics = _.reduce(definitions, function reducer(memo, definition) {
                if (_.isArray(definition)) {
                    return _.reduce(definition, reducer, memo);
                }
                return memo.concat(_.defaults({
                    limit: -1
                }, definition));
            }, []);

            return {
                type: 'metric',
                includeDimensionColumn: false,
                nameDimensions: me.getProp('nameDimensions'),
                metric: metrics,
                wideRow: false
            };
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.GLANCE_UNIVERSAL, GlanceWidget);

    const MetricView = RivalIQ.apps.Dashboard.widgets.MetricView.mixin({
        className: 'row col-sm-3',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        regions: {
            sparkline: '.x-sparkline-region'
        },

        onAttachLoaded: function () {
            const me = this;
            if (me.spark) {
                const data = _.map(me.spark.getValue({
                    format: false
                }), _.last);
                me.sparkline.show(new RivalIQ.graph.Spark({
                    data: data
                }));
            }
        },

        serializeData: function () {
            const me = this;

            const props = me.getProps();
            let submetricDisplayString = '%s';
            const selectedBenchmarkCompareAgainst = RivalIQ.apps.Overview.utils.getSelectedBenchmarkCompareAgainst(props.selectedBenchmarkCompareAgainst);
            if (props.selectedBenchmarkCompareAgainst) {

                const companies = RivalIQ.apps.Overview.utils.getCompaniesForFilter(selectedBenchmarkCompareAgainst.benchmarkCompaniesFilter, me);
                const companySetDescriptor = me.getProp('companySetDescriptor');

                if (_.size(companies) === 1 && !RivalIQ.state.utils.isOnlyCompanySet(companySetDescriptor)) {
                    submetricDisplayString = `${companies[0].get('name')}: %s`;
                } else {
                    submetricDisplayString = `${selectedBenchmarkCompareAgainst.abbreviatedName}: %s`;
                }
            }

            if (me.submetric) {
                me.submetric.attributes.displayString = submetricDisplayString;
            }

            const data = RivalIQ.apps.Dashboard.widgets.MetricView.prototype.serializeData.call(me, props);
            if (selectedBenchmarkCompareAgainst && _.has(data, ['warnings', 'submetric']) && _.isNull(data.submetric.unformattedValue)) {
                data.submetric.displayString = `${selectedBenchmarkCompareAgainst.abbreviatedName}:`;
            }

            return data;
        },

        getMetric: function () {
            const me = this;

            return me.getOption('metric');
        },

        getSubmetric: function () {
            const me = this;

            return me.getOption('submetric');
        }
    });

    const FocusCompanyGlance = RivalIQ.views.CollectionView.mixin({
        className: 'panel-body glance-widget',
        metricPropertiesToPersist: [
            'name',
            'dimensions',
            'timeAnalysisMode',
            'property',
            'channel',
            'showSparkline',
            'engagement_type',
            'impression_type',
            'reaction_type',
            'tweetType'
        ],

        childView: MetricView,
        childViewOptions: function (model, index) {
            const me = this;

            const m = model.attributes;
            const props = me.getProps();
            const metric = new RivalIQ.models.MetricDefinition({});

            const baseMetric = _.defaults({
                useUniversalMetricsApi: true
            }, _.pick(m, me.metricPropertiesToPersist), props);

            const submetric = me.determineSubmetric(baseMetric);
            return {
                dashboardModel: me.dashboardModel,
                props: {
                },
                metric: metric.build(baseMetric),
                submetric: (submetric ? metric.build(submetric) : null)
            };
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            companySetChangeReload: RivalIQ.apps.Shell.mixins.CompanySetChangeReload
        },

        dashboardModelEvents: {
            'change': 'onChange'
        },

        determineSubmetric: function (baseMetric) {
            const me = this;

            const props = me.getProps();
            const compareAgainst = props.selectedBenchmarkCompareAgainst;
            let submetric;
            if (compareAgainst) {
                const selectedBenchmarkCompareAgainst = RivalIQ.apps.Overview.utils.getSelectedBenchmarkCompareAgainst(compareAgainst);
                submetric = {
                    format: undefined,
                    // NOTE: companyId doesn't make sense for benchmark metrics, so make sure to remove it for these metrics.
                    dimensions: _.without(baseMetric.dimensions, 'companyId'),
                    aggregate: selectedBenchmarkCompareAgainst.aggregate,
                    benchmarkCompaniesFilter: selectedBenchmarkCompareAgainst.benchmarkCompaniesFilter,
                    clobberDimensions: true,
                    name: selectedBenchmarkCompareAgainst.name
                };
            } else {
                submetric = {
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                };
            }

            return _.defaults(submetric, baseMetric);
        },

        getMetricCollection: function () {
            const me = this;

            const rawMetrics = _.map(me.dashboardModel.metrics, function (m) {
                return _.defaults({
                    useUniversalMetricsApi: true
                }, _.pick(m, me.metricPropertiesToPersist));
            });

            return new Backbone.Collection(rawMetrics);
        },

        onRenderLoaded: function () {
            const me = this;

            // the HD class attached to the CD curation blows up title headers on single widget PDF export
            const curation = me.dashboardModel.getCuration();
            if (curation.isExportingPDF() && curation.getProp('instanceId') && curation.isCustomDashboard) {
                $('body').removeClass('export-hd');
            }
        },

        onChange: function () {
            const me = this;

            me.collection = me.getMetricCollection();
            me.reload();
        },

        initialize: function () {
            const me = this;

            me.dashboardModel = me.getOption('dashboardModel');
            me.collection = me.getMetricCollection();
        }
    });

    const curations = RivalIQ.enums.curation;

    function isInEditor(curationId) {
        return _.includes([
            curations.DASHBOARDS_WIDGET_EDIT,
            curations.DASHBOARDS_BUILDER
        ], curationId);
    }

    function accessibleMetrics(props, metrics) {
        return _.filter(metrics, function (metric) {
            return RivalIQ.metric.access.channel(metric, props);
        });
    }

    const CustomDashboardGlanceWidget = GlanceWidget.mixin({
        view: FocusCompanyGlance,
        viewMore: false,
        maxDimensionCount: _.constant(0),

        title: function () {
            const me = this;

            return me.getProp('title') || RivalIQ.strings.favorites_overview_glance_widget_title;
        },

        isSupported: function (props) {
            if (!props.metrics || props.metrics.length === 0) {
                return false;
            }

            if (!_.every(props.metrics, RivalIQ.metric.property.isNumeric)) {
                return false;
            }

            return true;
        },

        filter: function () {
            const me = this;

            if (me.neverFilter) {
                return false;
            }

            const props = me.getProps();

            props.metrics = accessibleMetrics(props, props.metrics);
            return !isInEditor(me.curation.id) && !me.isSupported(props);
        },

        // NOTE: this removes the metric description on PPT export
        getSlideDescriptions: _.constant([]),

        getExportWidthClass: _.constant(undefined),

        getExportMetricDefinitions: function (format) {
            const me = this;

            const collection = new RivalIQ.collections.MetricDefinitions(me.metrics);
            return collection.invoke('serialize', format);
        },

        getExportSubtitle: function () {
            const me = this;
            if (me.isFocus()) {
                const timezone = RivalIQ.state.landscape.get('timezone');
                return RivalIQ.utils.timePeriod.getTimePeriodDisplayString(me.getProp('timePeriod'), null, timezone);
            }
        },

        propValues: {
            columnWidth: [12],
            timeAnalysisMode: [
                RivalIQ.enums.timeAnalysisMode.MAIN_PERIOD,
                RivalIQ.enums.timeAnalysisMode.DAILY_VALUES,
                RivalIQ.enums.timeAnalysisMode.COMPARE_PERIOD,
                RivalIQ.enums.timeAnalysisMode.DELTA_ABSOLUTE,
                RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
            ]
        }
    });

    const FocusCompanyGlanceWidget = CustomDashboardGlanceWidget.mixin({

        processProps: function (props) {
            const me = this;

            props.companyId = props.focusCompanyId;
            me.metrics = me.buildMetrics(props);
            props.doNotRebuildMetrics = true;
            props.submetricDisplayType = props.selectedBenchmarkCompareAgainst ? '' : 'upDownCarets';
            props.useUniversalMetricsApi = true;
            props.columnWidth = _.head(me.propValues.columnWidth);
            props.nameDimensions = ['channel', 'timeAnalysisMode'];
            if (!props.focusCompanyTitlePlacement) {
                props.focusCompanyTitlePlacement = RivalIQ.enums.widgetFocusCompanyTitlePlacement.PREFIX;
            }

            // See #33526, we can't unset format if we're in the process of scheduling a report.
            if (!props.scheduleId) {
                props.format = undefined;
            }

            return props;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.FOCUS_COMPANY_GLANCE, FocusCompanyGlanceWidget);

    const LandscapeGlance = FocusCompanyGlance.extend({

        metricPropertiesToPersist: FocusCompanyGlance.prototype.metricPropertiesToPersist.concat(['aggregate', 'benchmarkCompaniesFilter']),

        determineSubmetric: function (baseMetric) {
            const me = this;

            const compareAgainst = me.getProp('selectedBenchmarkCompareAgainst');
            if (compareAgainst === 'previousPeriod') {
                return _.defaults({
                    timeAnalysisMode: RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE
                }, baseMetric);
            }
        }
    });

    const LandscapeGlanceWidget = CustomDashboardGlanceWidget.extend({
        view: LandscapeGlance,

        hasFooter: _.constant(true),
        footerView: RivalIQ.apps.Dashboard.views.WarningLegendFooterView,

        title: function () {
            const me = this;

            return me.getProp('title') || RivalIQ.strings.favorites_landscape_glance_widget_title;
        },

        processProps: function (props) {
            const me = this;

            props.aggregate = null;
            props.benchmarkCompaniesFilter = null;
            const metrics = me.buildMetrics(props);
            me.metrics = _.map(metrics, (metric, idx) => {
                const summaryMetric = _.get(props, ['customSummaryMetrics', idx]) || 'all_companies_average';
                const selectedBenchmarkCompareAgainst = RivalIQ.apps.Overview.utils.getSelectedBenchmarkCompareAgainst(summaryMetric);
                return RivalIQ.metric.build(metric, {
                    aggregate: selectedBenchmarkCompareAgainst.aggregate,
                    benchmarkCompaniesFilter: selectedBenchmarkCompareAgainst.benchmarkCompaniesFilter
                });
            });

            props.doNotRebuildMetrics = true;
            props.submetricDisplayType = 'upDownCarets';
            props.useUniversalMetricsApi = true;
            props.columnWidth = _.head(me.propValues.columnWidth);
            props.nameDimensions = ['channel', 'timeAnalysisMode'];

            // See #33526, we can't unset format if we're in the process of scheduling a report.
            if (!props.scheduleId) {
                props.format = undefined;
            }

            return props;
        }
    });
    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.LANDSCAPE_GLANCE, LandscapeGlanceWidget);
});
